import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export const notifyOfferAccepted = async (helperEmail, helperName, requesterName, requestTitle) => {
  try {
    await addDoc(collection(db, 'notifications'), {
      to: helperEmail,
      message: `${requesterName} accepted your help offer for "${requestTitle}"`,
      type: 'offer',
      read: false,
      createdAt: serverTimestamp()
    });
  } catch (err) {
    console.error('Error sending offer accepted notification:', err);
  }
};

export const notifySessionComplete = async (helperEmail, helperName, requesterName, rating) => {
  try {
    await addDoc(collection(db, 'notifications'), {
      to: helperEmail,
      message: `${requesterName} completed the session and rated you ${rating}/5 stars!`,
      type: 'review',
      read: false,
      createdAt: serverTimestamp()
    });
  } catch (err) {
    console.error('Error sending session complete notification:', err);
  }
};

export const notifyHelpOffered = async (requesterEmail, requesterName, helperName, requestTitle) => {
  try {
    await addDoc(collection(db, 'notifications'), {
      to: requesterEmail,
      message: `${helperName} offered to help with "${requestTitle}"`,
      type: 'offer',
      read: false,
      createdAt: serverTimestamp()
    });
  } catch (err) {
    console.error('Error sending help offered notification:', err);
  }
};

export const sendNotification = async (to, message, type = 'general') => {
  try {
    await addDoc(collection(db, 'notifications'), {
      to,
      message,
      type,
      read: false,
      createdAt: serverTimestamp()
    });
  } catch (err) {
    console.error('Error sending notification:', err);
  }
};
